module.exports = __webpack_public_path__ + "static/media/integration.7b98304b.gif";